import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../../forms';

@Component({
  selector: 'pty-customer-telecom',
  templateUrl: './cutomer-telecom.component.html',
  styleUrls: ['./cutomer-telecom.component.scss']
})
export class CutomerTelecomComponent implements OnChanges{
  @Input() partyId:string;
  listForm:OfbizList;

  title:"PostalAddresses";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerTelecomNumber",
        listFormLocation:"component://kwikstore/widget/PartyForms.xml",
        columnFields:getFields("CustomerTelecomNumber",PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerTelecomNumber",PART_FORMS),
        //fieldFormFields:any,
        listType:"grid",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerTelecomNumber",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"CustomerTelecomNumber",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerTelecomNumber",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerTelecomNumber",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }

  handleHyperLinkSelected(e){

  }

  handleListSucessNotify(e){

  }

  showOverview(e){

  }

  showEditDialog(e){

  }
}
